/**
 * @flow
 * @relayHash d994009fdd7fd5e6b7529d5a2e461e63
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlantList_viewer$ref = any;
export type PlantListQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  edibles?: ?boolean,
|};
export type PlantListQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +$fragmentRefs: PlantList_viewer$ref,
  |}
|};
export type PlantListQuery = {|
  variables: PlantListQueryVariables,
  response: PlantListQueryResponse,
|};
*/


/*
query PlantListQuery(
  $count: Int!
  $cursor: String
  $search: String
  $edibles: Boolean
) {
  viewer {
    id
    ...PlantList_viewer_1sHpaq
  }
}

fragment PlantList_viewer_1sHpaq on Query {
  allLifeNode(first: $count, after: $cursor, search: $search, edibles: $edibles) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        ...PlantItem_lifeNode
        __typename
      }
      cursor
    }
  }
}

fragment PlantItem_lifeNode on LifeNode {
  id
  idInt
  title
  slug
  rankDisplay
  commonName {
    name
    id
  }
  images(first: 1) {
    edges {
      node {
        id
        bigImage: image(width: 440, height: 520) {
          url
        }
      }
    }
  }
  commonNames(first: 20) {
    edges {
      node {
        id
        name
        language
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "edibles",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "edibles",
  "variableName": "edibles"
},
v3 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PlantListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "PlantList_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PlantListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "allLifeNode",
            "storageKey": null,
            "args": (v4/*: any*/),
            "concreteType": "LifeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "LifeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LifeNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "idInt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "rankDisplay",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "commonName",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CommonName",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "images",
                        "storageKey": "images(first:1)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          }
                        ],
                        "concreteType": "ImageConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ImageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Image",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": "bigImage",
                                    "name": "image",
                                    "storageKey": "image(height:520,width:440)",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "height",
                                        "value": 520
                                      },
                                      {
                                        "kind": "Literal",
                                        "name": "width",
                                        "value": 440
                                      }
                                    ],
                                    "concreteType": "File",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "url",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "commonNames",
                        "storageKey": "commonNames(first:20)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 20
                          }
                        ],
                        "concreteType": "CommonNameConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CommonNameEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CommonName",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "language",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "allLifeNode",
            "args": (v4/*: any*/),
            "handle": "connection",
            "key": "ListLifeNode_allLifeNode",
            "filters": [
              "search",
              "edibles",
              "edibility",
              "rank",
              "flowerColors",
              "leafType",
              "phyllotaxy",
              "flowerTypes",
              "fruitType",
              "growthHabit",
              "threatened"
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PlantListQuery",
    "id": null,
    "text": "query PlantListQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $edibles: Boolean\n) {\n  viewer {\n    id\n    ...PlantList_viewer_1sHpaq\n  }\n}\n\nfragment PlantList_viewer_1sHpaq on Query {\n  allLifeNode(first: $count, after: $cursor, search: $search, edibles: $edibles) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        ...PlantItem_lifeNode\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment PlantItem_lifeNode on LifeNode {\n  id\n  idInt\n  title\n  slug\n  rankDisplay\n  commonName {\n    name\n    id\n  }\n  images(first: 1) {\n    edges {\n      node {\n        id\n        bigImage: image(width: 440, height: 520) {\n          url\n        }\n      }\n    }\n  }\n  commonNames(first: 20) {\n    edges {\n      node {\n        id\n        name\n        language\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b65d7414f3d25957da56c9423d63590f';
module.exports = node;
